var console = require("./logger.js");
var Oop = require("./oop.js");
var MessageProxy = require("./messageproxy.js");
var CallbackTable = require("./callbacktable.js");



function MessageProxyGroup () {

    this._messageCallbackTable = new CallbackTable();
    this._messageProxyArray = [];
    this._messagesForNew = [];

    var me = this;

    this._messageCallbackWrapper = function (messageObject, messageProxy) {

        me._messageCallback(messageObject, messageProxy);
    };
}
MessageProxyGroup.name = "MessageProxyGroup";

Oop.borrow(MessageProxyGroup, MessageProxy, [
    "onMessage",
    "oneMessage",
    "offMessage",
    "_message",
    "_messageCallbackTable",
    "_messageCallbackWrapper",
    "_doMessageCallback",
    "_doCallback"
]);

MessageProxyGroup.prototype._messageProxyArray = null;

MessageProxyGroup.prototype._messagesForNew = null;

MessageProxyGroup.prototype._hasSameTarget = function (proxyA, proxyB) {

    if (proxyA === proxyB) {

        return true;
    }

    return proxyA.hasSameTarget(proxyB);
};

MessageProxyGroup.prototype.isAlreadyAdded = function (messageProxy, compareFunc) {

    if (compareFunc == null) {

        compareFunc = this._hasSameTarget;
    }

    for (var index = 0; index < this._messageProxyArray.length; index++) {

        if (compareFunc(this._messageProxyArray[index], messageProxy) === true) {

            return this._messageProxyArray[index];
        }
    }

    return null;
};

MessageProxyGroup.prototype.addMessageProxy = function (messageProxy) {

    if (messageProxy._isTargetInfoValid() === false) {

        return this;
    }

    if (this.isAlreadyAdded(messageProxy) != null) {
        return this;
    }

    messageProxy.onMessage("*", this._messageCallbackWrapper);
    this._messageProxyArray.push(messageProxy);

    for (var index = 0; index < this._messagesForNew.length; index++) {

        var cachedObject = this._messagesForNew[index];

        this._doFilterAndPostMessage(messageProxy, cachedObject.messageObject, cachedObject.filterFunc);
    }

    return this;
};

MessageProxyGroup.prototype._doFilterAndPostMessage = function (messageProxy, messageObject, filterFunc) {

    if (filterFunc == null) {

        this._doPostMessage(messageProxy, messageObject);
        return;
    }

    if (filterFunc(messageProxy, messageObject) === true) {

        this._doPostMessage(messageProxy, messageObject);
    }
};

MessageProxyGroup.prototype._doPostMessage = function (messageProxy, messageObject) {

    messageProxy.postMessage(
        messageObject.messageId,
        messageObject.message,
        messageObject.senderId
    );
};

MessageProxyGroup.prototype.removeMessageProxy = function (messageProxy) {

    var index = 0;
    var messageProxyTmp = null;

    if (messageProxy == null) {

        for (index = 0; index < this._messageProxyArray.length; index++) {

            messageProxyTmp = this._messageProxyArray[index];

            messageProxyTmp.offMessage("*", this._messageCallbackWrapper);
        }

        this._messageProxyArray.length = 0;

    } else {

        var messageProxyArrayTmp = [];

        for (index = 0; index < this._messageProxyArray.length; index++) {

            messageProxyTmp = this._messageProxyArray[index];

            if (messageProxyTmp === messageProxy) {
                
                messageProxyTmp.offMessage("*", this._messageCallbackWrapper);

            } else {

                messageProxyArrayTmp.push(messageProxyTmp);
            }
        }

        this._messageProxyArray = messageProxyArrayTmp;
    }

    return this;
};

MessageProxyGroup.prototype.broadcastMessage = function (messageId, message, senderId, keepForNew, filterFunc) {

    var messageObject = {
        messageId: messageId,
        message: message,
        senderId: senderId
    };

    this._doBroadcastMessage(messageObject, keepForNew, filterFunc);

    return this;
};

MessageProxyGroup.prototype._doBroadcastMessage = function (messageObject, keepForNew, filterFunc) {

    console.log(__GLOBAL_LOG_PREFIX__, "["+this.constructor.name+"][_doBroadcastMessage]:"+messageObject.messageId);

    if (keepForNew == null) {
        keepForNew = false;
    }

    for (var index = 0; index < this._messageProxyArray.length; index++) {

        var messageProxy = this._messageProxyArray[index];

        this._doFilterAndPostMessage(messageProxy, messageObject, filterFunc);
    }

    if (keepForNew === true) {

        var matchedIndex = this._findMatchedMessage(messageObject);

        if (matchedIndex >= 0) {

            // same as update
            this._messagesForNew[matchedIndex] = {messageObject: messageObject, filterFunc: filterFunc};

        } else {

            // add new
            this._messagesForNew.push({messageObject: messageObject, filterFunc: filterFunc});
        }
    }
};

MessageProxyGroup.prototype.updateMessage = function (messageId, message, senderId, filterFunc) {

    var messageObject = {
        messageId: messageId,
        message: message,
        senderId: senderId
    };

    this._doUpdateMessage(messageObject, filterFunc);

    return this;
};

MessageProxyGroup.prototype._doUpdateMessage = function (messageObject, filterFunc) {

    console.log(__GLOBAL_LOG_PREFIX__, "["+this.constructor.name+"][_doUpdateMessage]:"+messageObject.messageId);

    var matchedIndex = this._findMatchedMessage(messageObject);

    if (matchedIndex >= 0) {

        this._messagesForNew[matchedIndex] = {messageObject: messageObject, filterFunc: filterFunc};
    }
};

MessageProxyGroup.prototype._isSameMessageId = function (messageObjA, messageObjB) {

    if (messageObjA == null ||
        messageObjA.messageId == null ||
        messageObjB == null ||
        messageObjB.messageId == null) {

        return false;
    }

    if (messageObjA.messageId === messageObjB.messageId) {

        return true;
    }

    return false;
};

MessageProxyGroup.prototype._findMatchedMessage = function (messageObject, compareFunc) {

    console.log(__GLOBAL_LOG_PREFIX__, "["+this.constructor.name+"][_findMatchedMessage]: " + messageObject.messageId);

    if (compareFunc == null) {

        compareFunc = this._isSameMessageId;
    }

    var messagesForNew = this._messagesForNew;

    var matchedIndex = -1;

    for (var index = 0; index < messagesForNew.length; index++) {

        var cachedObject = messagesForNew[index];

        if (compareFunc(cachedObject.messageObject, messageObject) === true) {

            matchedIndex = index;
            break;
        }
    }

    return matchedIndex;
};

MessageProxyGroup.prototype._messageCallback = function (messageObject, messageProxy) {

    this._doMessageCallback(messageObject, messageProxy);
};

module.exports = MessageProxyGroup;


